module.exports = __webpack_public_path__ + "static/media/facebook.ab135bfd.svg";